import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { RoomCallPreviewPopup } from 'APP/main/PopupManager/Popups/RoomCallPreviewPopup/RoomCallPreviewPopup';
import { RouterParams } from 'APP/router/constants';
import useGetParameter from 'APP/router/hooks/useGetParameter';

export async function useRoomCallHandlerPresenter(): Promise<void> {
  const roomCallChannelId = useGetParameter(RouterParams.roomCallChannelId);

  useEffect(() => {
    if (roomCallChannelId) {
      Tasks.app.openPopup(RoomCallPreviewPopup, { params: { channelId: roomCallChannelId } });
    }
  }, [roomCallChannelId]);
}
